module.exports = __webpack_public_path__ + "static/media/3 leg color face black.1280x1600.3b925bae.webp";